import React from 'react';
import { wg_logo, poweredby } from '../../../images';
import {formatNow} from "../../../services/UtilityService";

const TeamMapFooter = () => {
	const currentYear = formatNow();

	return (
		<div className='PageFooter' style={{borderTop: 'none'}}>
			<div className='PageFooter__layout'>
				<div className='PageFooter__logo'>
					<img width='111' src={wg_logo} />
				</div>

				<div className='PageFooter__textContainer'>
					<p className='PageFooter__paragraph'>www.WorkingGenius.com</p>
					<p className='PageFooter__paragraph'> © Copyright {currentYear} The Table Group, Inc. </p>
				</div>

				<div className='powered-by'>
					<img width='115' src={poweredby} />
				</div>
			</div>
		</div>
	);
};

export default TeamMapFooter;
